<template>
  <section class="ant-layout">
    <main class="ant-layout-content">
      <div class="ant-spin-nested-loading">
        <div class="ant-spin-container">
          <div class="credit-page">
            <div class="common-header"><span>{{ $t('mine.Quota') }}</span></div>
            <div class="credit-page-assets-wrapper">
              <div class="credit-page-assets-wrapper-left-right">
                <div class="credit-page-assets-wrapper-left">
                  <div class="balance-wallet">
                    <div class="wallet-balance">
                      <span>Balance</span>
                      <span class="money" style="min-width: 110px; display: inline-block" v-if="nshow">￥{{ $store.state.userInfo.balance }}</span>
                      <span class="money" style="min-width: 110px; display: inline-block" v-else>￥******</span>

                      <span @click="changBshow"><img src="/static/image/password_display@2x.9b192d5d.png" alt="" /></span>
                    </div>
                    <div class="async-time">
                      <div>
                        <div role="switch" class="el-switch" @click="changeTasfer" v-if="$store.state.userInfo.transferstatus == 0"><input type="checkbox" name="" true-value="1" false-value="0" class="el-switch__input" value="on" /><span class="el-switch__core" style="width: 40px"></span></div>
                        <div role="switch" class="el-switch is-checked" @click="changeTasfer" v-if="$store.state.userInfo.transferstatus == 1" aria-checked="true">
                          <input type="checkbox" name="" true-value="1" false-value="0" class="el-switch__input" value="on" /><span class="el-switch__core" style="width: 40px"></span>
                        </div>
                        <span style="margin-left: 20px" class="el-tag el-tag--success el-tag--dark">{{ $store.state.userInfo.transferstatus == 0 ? $t('mine.transfermode') : $t('mine.Spin') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="credit-page-assets-wrapper-right">
                  <div class="credit-page-assets-wrapper-right-btn">
                    <span class="one-key-fresh" @click="getBalances" style="padding: 0; justify-content: center; align-items: center">{{ $t('mine.refresh') }}</span> <span class="one-key-recycle" style="padding: 0; justify-content: center; align-items: center" @click="transall">{{ $t('mine.recycling') }}</span>
                  </div>
                  <div class="credit-page-assets-wrapper-right-text">{{ $t('mine.Click') }}</div>
                </div>
              </div>
            </div>
            <div class="credit-page-api-wrapper">
              <dl v-for="(item, index) in balancelist" :key="index" v-if="index != 0" @click="changVal(item)">
                <dt><img :src="`/static/image/${item.platname}.png`" :style="item.platname == 'xjty' || item.platname == 'hgty' ? `height:50%` : `border-radius: 50%;` " alt="icon" /></dt>
                <dd>
                  <p>{{ item.name }}</p>
                  <p>{{ item.balance }}</p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="el-dialog__wrapper" style="background: rgba(0, 0, 0, 0.4)" v-if="openInfo.name">
        <div role="dialog" aria-modal="true"  class="el-dialog" style="margin-top: 15vh">
          <div class="el-dialog__header">
            <span class="el-dialog__title"></span><button type="button" @click="closeCv"  class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
          </div>
          <div class="el-dialog__body">
            <form class="el-form el-form--inline">
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item">
                  <label class="el-form-item__label" style="width: 150px"
                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Account') }}</font></font></label
                  >
                  <div class="el-form-item__content">
                    <div class="el-input is-disabled"><input type="text" disabled="disabled" autocomplete="off" :value="$store.state.userInfo.balance" :placeholder="$t('mine.Account')" class="el-input__inner" /></div>
                    
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item">
                  <label class="el-form-item__label" style="width: 150px"
                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.balance') }}</font></font></label
                  >
                  <div class="el-form-item__content">
                    <div class="el-input is-disabled"><input type="text" disabled="disabled" :value="openInfo.balance" autocomplete="off" :placeholder="$t('mine.balance')" class="el-input__inner" /></div>
                    
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-required">
                  <label for="bank_address" class="el-form-item__label" style="width: 150px"
                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.titransfert') }}</font></font></label
                  >
                  <div class="el-form-item__content">
                    <el-radio v-model="payType" :label="0">{{ $t('mine.transferin') }}</el-radio>
                    <el-radio v-model="payType" :label="1">{{ $t('mine.transferout') }}</el-radio>
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
                <div class="el-form-item is-success is-required">
                  <label for="money" class="el-form-item__label" style="width: 150px"
                    ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.Action') }}</font></font></label
                  >
                  <div class="el-form-item__content">
                    <div class="el-input"><input type="text" autocomplete="off" v-model="amount" :placeholder="$t('mine.Fill') " class="el-input__inner" /></div>
                    
                  </div>
                </div>
              </div>
              <div class="grid-content bg-purple el-row" style="margin-left: -10px; margin-right: -10px">
                <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px"><div class="grid-content bg-purple"></div></div>
                <div class="el-col el-col-16" style="padding-left: 10px; padding-right: 10px">
                  <button type="button" class="el-button el-button--primary" @click="isOk">
                    <span
                      ><font style="vertical-align: inherit"><font style="vertical-align: inherit">{{ $t('mine.confirm') }}</font></font></span
                    >
                  </button>
                </div>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </main>
  </section>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return {
      nshow: true,
      balancelist: [],
      openInfo: {},
      amount: null,
      payType: 0,
      daoTime: null,
    };
  },
  created() {
    let that = this;
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 2500);
  },
  methods: {
    getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist2', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: that.$t('mine.Platform') });
            that.balancelist = balancelist;
          }
        })
        .catch(res => {});
    },
    isOk() {
      let that = this;

      let sourcetype = '';
      let targettype = '';

      if (that.payType == 0) {
        //转入游戏
        sourcetype = 'userbalance';
        targettype = that.openInfo.platname;
      } else {
        //转入平台
        sourcetype = that.openInfo.platname;
        targettype = 'userbalance';
      }
      let info = { amount: that.amount, sourcetype: sourcetype, targettype: targettype };
      if (that.amount == null) {
        that.showTost(0, that.$t('mine.operation'));
        return;
      }

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.closeCv();
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      });
    },
    changVal(item) {
      let that = this;
      if (that.$store.state.userInfo.transferstatus == 1) {
        return;
      }
      that.openInfo = item;
      that.amount = null;
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
    },
    changeTasfer() {
      let that = this;
      that.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.showTost(1, that.$t('mine.Successful'));
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getBalances() {
      let that = this;
      that.showLoading();
      that.getbalancelist();

      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.hideLoading();
        })
        .catch(res => {
          // console.log(res)
          that.hideLoading();
        });
    },
    getbalancelist() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            balancelist.forEach(element => {
              element.balance = '读取中..'
            });
            that.balancelist = balancelist;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changBshow() {
      this.nshow = !this.nshow;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/credit.00fbe2a1.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/transfer.vue